module.exports = __webpack_public_path__ + "img/growthAbility6.5368d6c5.png";